module.exports = __webpack_public_path__ + "static/media/27OCHA15.fb48ff58.jpg";